//This is the functionality for the entrant
EMMY.dynamicFieldsAdmin = {
  init: function () {

    // Get a list of fields which are dependent (these are the parents or 'selectors').
    var dataList = $('#entry-fulldetails-form, .entry-review--summary').find(".form-group-beside, .form-group-beside-hold, .full-instructions-wrapper").map(function() {
      return $(this).data("dynamic-name");
    }).get();

    if(dataList.length > 0) {
      var allClasses = '.' + dataList.join(",.");
      $(allClasses).on('change', function (e) {
        var changedElementGroup = $(this).attr('class').split(' ');
        var dynamicElementClass = changedElementGroup[changedElementGroup.length - 1];
        if ($(this).hasClass('toggle')) {
          var valueOfDynamicField = $(this).parent().find('.form-control:checked').val();
        } else {
          var valueOfDynamicField = $(this).val();
        }

        // This is the code when the dynamic field equals the trigger result
        // In this case we really just have to set the required fields BACK to their required state.
        var dynamicDataEqual = $('[data-dynamic-name="' + dynamicElementClass + '"][data-dynamic-value="' + valueOfDynamicField + '"]');
        dynamicDataEqual.show();

        if (dynamicDataEqual.hasClass('dynamic-required')) {
          $('[data-dynamic-name="' + dynamicElementClass + '"][data-dynamic-value="' + valueOfDynamicField + '"]').find('.form-control, .requiredFile').attr('required', true);
        }

        // This is the code when the dynamic field DOES NOT equals the trigger result
        // In this case we must hide the field, remove the required attribute, required class (if set) and clear the data from the field.
        var dynamicDataNotEqual = $('[data-dynamic-name="' + dynamicElementClass + '"][data-dynamic-value!="' + valueOfDynamicField + '"]');
        dynamicDataNotEqual.hide();

        dynamicDataNotEqual.each(function (i, v) {
          $(this).removeClass('required');
          $(this).find('.form-control, .requiredFile').removeAttr('required');
          if ($(this).find('.form-control').hasClass('toggle')) {
            $(this).find('.form-control').removeAttr('checked');
            $(this).find('.toggle-js span').removeClass('active');
          } else if ($(this).find('.form-control').hasClass('select2-hidden-accessible')) {
            $(this).find('.form-control').val('').trigger('change');
          } else if ($(this).find('.form-control').hasClass('checkbox-field-form')) {
            // console.log('this one? remove checkbox');
            $(this).find('.form-control').removeAttr('checked');
          } else if ($(this).hasClass('episode_name_block')) {
            // console.log('remove episode details blocks (except first), clear inputs and hide remove button');
            $(this).find('.episode_details:not(:first)').remove();
            $(this).find('.episode_details .form-control').val('');
            $('.episode_name_block').each(function (i, v) {
              EMMY.customFields.initialEpisodeChecker(this);
            });
          } else {
            $(this).find('.form-control').val('');
          }
        });

      });

      $(allClasses).trigger('change');
    }

  }
}